var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"px-1 mt-2"},[_c('v-row',{staticClass:"px-1 mx-1"},[_c('v-col',{staticClass:"px-1 py-1 timestamp"},[_vm._v(_vm._s(_vm.timestamp))])],1),_c('v-row',{staticClass:"px-1 mx-1 mb-1"},[_c('v-col',{staticClass:"px-1 py-1 text"},[_vm._v(" "+_vm._s(_vm.text))])],1),_c('hr')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }